import React from "react";
import { Tabs } from "@material-ui/core";
import { makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) => ({
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
    minHeight: 500,
    "& .MuiTab-wrapper": {
      textAlign: "left",
      alignItems: "start",
      marginLeft: 5,
    },
    "& .MuiTab-root": {
      textAlign: "left",
      minHeight: "38px",
    },
  },
  indicator: {
    "&.MuiTabs-indicator": {
      left: 0,
      width: 5,
    },
  },
}));
interface Props {
  handleChange: any;
  value: string | number;
  tabMinHeight?: number;
  children: any;
  tabMin2Height?: any;
}

export default function CommonTabs({
  handleChange,
  value,
  tabMinHeight,
  children,
  tabMin2Height,
}: Props) {
  const classes = useStyles();
  return (
    <>
      <Tabs
        orientation="vertical"
        variant="scrollable"
        scrollButtons="auto"
        value={value}
        onChange={handleChange}
        className={classes.tabs}
        selectionFollowsFocus
        classes={{ indicator: classes.indicator }}
        style={{ height: tabMinHeight || "inherit", minHeight: tabMin2Height || "" }}
      >
        {children}
      </Tabs>
    </>
  );
}
